<div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6 bg-neon-leaf py-5 lg:py-10 px-5 border-2 border-secondary">
  <div class="flex flex-col gap-1">
    <p class="text-sm text-text-secondary">
        Made with <span class="text-scarlet-rush text-base">❤️</span> by Adelya Musaeva
      </p>
    <h1 class="text-2xl md:text-4xl font-bold">{{ title() }}</h1>
  </div>

  <div class="flex items-center gap-3 md:gap-4">
    <!-- Collaborators Avatars -->
    @if (collaborators().length > 0) {
    <div class="flex items-center -space-x-2 md:-space-x-3">
      @for (collaborator of collaborators(); track collaborator.id) {
      <div
        class="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-secondary overflow-hidden bg-gray-200"
        [title]="collaborator.displayName"
      >
        <img
          [src]="collaborator.photoURL"
          [alt]="collaborator.displayName"
          class="w-full h-full object-cover"
        />
      </div>
      }
    </div>
    }

    <!-- Invite Button -->
    <button
      class="flex items-center gap-2 bg-accent  border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] px-3 md:px-4 py-2 md:py-3 text-sm md:text-base  transition-all hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] cursor-pointer"
      (click)="inviteClicked.emit()"
    >
      <ng-icon name="heroUserPlusSolid" size="1.25rem" class="md:text-xl"></ng-icon>
      <span class="hidden sm:inline">Invite People</span>
      <span class="sm:hidden">Invite</span>
    </button>

    @if (isOwner()) {
    <button
      class="flex items-center gap-2 bg-scarlet-rush text-white hover:bg-red-600 border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] px-3 md:px-4 py-2 md:py-3 text-sm md:text-base transition-all hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] cursor-pointer"
      (click)="deleteClicked.emit()"
      title="Delete Project"
    >
      <ng-icon name="heroTrashSolid" size="1.25rem" class="md:text-xl"></ng-icon>
      <span class="hidden md:inline">Delete</span>
    </button>
    }
  </div>
</div>